import { render, staticRenderFns } from "./FeStarTrendChart.vue?vue&type=template&id=07211dec&scoped=true"
import script from "./FeStarTrendChart.vue?vue&type=script&lang=js"
export * from "./FeStarTrendChart.vue?vue&type=script&lang=js"
import style0 from "./FeStarTrendChart.vue?vue&type=style&index=0&id=07211dec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07211dec",
  null
  
)

export default component.exports